export default "__VITE_ASSET__CoadaiYa__"